import { useContext } from 'react';
import FeedContext from './FeedContext';

const useFeedContext = () => useContext(FeedContext);

export default useFeedContext;

